export default "__VITE_ASSET__CjD_lCS5__"